import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import {
    captionsReducer,
    CAPTIONS_REDUCER_NAME,
} from './captions/captions.slice';
import { FLOWS_REDUCER_NAME, flowsReducer } from './flows/flows.slice';
import { reelsReducer, REELS_REDUCER_NAME } from './reels/reels.slice';
import { usersReducer, USERS_REDUCER_NAME } from './users/users.slice';
import { FLYOVER_REDUCER_NAME, flyoverReducer } from './flyover/flyover.slice';

export const store = configureStore({
    reducer: {
        [CAPTIONS_REDUCER_NAME]: captionsReducer,
        [FLOWS_REDUCER_NAME]: flowsReducer,
        [REELS_REDUCER_NAME]: reelsReducer,
        [USERS_REDUCER_NAME]: usersReducer,
        [FLYOVER_REDUCER_NAME]: flyoverReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export function useAppSelector<T>(selector: (state: RootState) => T) {
    return useSelector(selector);
}

export function useAppDispatch() {
    return useDispatch<AppDispatch>();
}
